export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getAllCustomers() {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/customer/all")
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        getPaginatedCustomers(_, page) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/customer/index?page=" + page)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        deleteCustomer(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/customer/delete/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        createCustomer(_, data) {
            let formData = new FormData();
            Object.keys(data).forEach(key => {
                if (data[key]) {
                    formData.append(key, data[key])
                }
            });
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/customer/store", formData)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateCustomer(_, payload) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/customer/update/" + payload.identifier, payload.data)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        singleCustomer(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/customer/show/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        toggleCustomerStatus(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/customer/toggle-status/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
    },
}

